/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportType,
    ReportTypeFromJSON,
    ReportTypeFromJSONTyped,
    ReportTypeToJSON,
} from './ReportType';
import {
    StudyProgram,
    StudyProgramFromJSON,
    StudyProgramFromJSONTyped,
    StudyProgramToJSON,
} from './StudyProgram';

/**
 * 
 * @export
 * @interface OtherRelevantDocumentsReport
 */
export interface OtherRelevantDocumentsReport {
    /**
     * 
     * @type {string}
     * @memberof OtherRelevantDocumentsReport
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof OtherRelevantDocumentsReport
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OtherRelevantDocumentsReport
     */
    updatedAt?: Date;
    /**
     * 
     * @type {ReportType}
     * @memberof OtherRelevantDocumentsReport
     */
    reportType?: ReportType;
    /**
     * 
     * @type {Date}
     * @memberof OtherRelevantDocumentsReport
     */
    reportDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof OtherRelevantDocumentsReport
     */
    filePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherRelevantDocumentsReport
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherRelevantDocumentsReport
     */
    studyProgramId?: string;
    /**
     * 
     * @type {StudyProgram}
     * @memberof OtherRelevantDocumentsReport
     */
    studyProgram?: StudyProgram;
}

export function OtherRelevantDocumentsReportFromJSON(json: any): OtherRelevantDocumentsReport {
    return OtherRelevantDocumentsReportFromJSONTyped(json, false);
}

export function OtherRelevantDocumentsReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherRelevantDocumentsReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'reportType': !exists(json, 'reportType') ? undefined : ReportTypeFromJSON(json['reportType']),
        'reportDate': !exists(json, 'reportDate') ? undefined : (new Date(json['reportDate'])),
        'filePath': !exists(json, 'filePath') ? undefined : json['filePath'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'studyProgram': !exists(json, 'studyProgram') ? undefined : StudyProgramFromJSON(json['studyProgram']),
    };
}

export function OtherRelevantDocumentsReportToJSON(value?: OtherRelevantDocumentsReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'reportType': ReportTypeToJSON(value.reportType),
        'reportDate': value.reportDate === undefined ? undefined : (value.reportDate.toISOString()),
        'filePath': value.filePath,
        'description': value.description,
        'studyProgramId': value.studyProgramId,
        'studyProgram': StudyProgramToJSON(value.studyProgram),
    };
}

